import { MainHistory } from 'features/search';

export const History = () => {
	return (
		<>
			<MainHistory />
		</>
	);
};
